import {loadAllGroupsMenuItems, loadMenuGroups, loadtMenuItemTypes} from './menuActions';
import {loadBranchInfo} from './branchActions';
import {hideLoading, showLoading} from './loadingActions';
import {loadPaymentTypes} from './paymentActions';

export const setLanguageId = data => ({
  type: 'SET_LANGUAGE_ID',
  data,
});

export const setUiLanguageId = data => ({
  type: 'SET_UI_LANGUAGE_ID',
  data,
});

export const setDeliveryType = data => ({
  type: 'SET_DELIVERY_TYPE',
  data,
});

export const setOrderGuidCode = data => ({
  type: 'SET_ORDER_GUID_CODE',
  data,
});

export const setTableId = data => ({
  type: 'SET_TABLE_ID',
  data,
});

export const setOrderTips = data => ({
  type: 'SET_ORDER_TIPS',
  data,
});

export const setOrderType = data => ({
  type: 'SET_ORDER_TYPE',
  data,
});

export const setBranchMessageShown = data => ({
  type: 'SET_BRANCH_MESSAGE_SHOWN',
  data,
});

export const setGeneralErrorTranslationKey = data => ({
  type: 'SET_GENERAL_ERROR_TRANSLATION_KEY',
  data,
});

export const loadRestaurant = (branchId, withMenuItems = false) => async (dispatch) => {
  dispatch(showLoading());
  const res = await dispatch(loadBranchInfo(branchId));
  if (withMenuItems) {
    await dispatch(loadPaymentTypes());
    await dispatch(loadtMenuItemTypes());
    await dispatch(loadMenuGroups());
    await dispatch(loadAllGroupsMenuItems());
  }

  dispatch(hideLoading());  
  return res;
};
